import React from 'react';
import Typewriter from 'typewriter-effect';
import { images } from '../../constants';
import './AboutUs.css';

const AboutUs = () => (
  <div className="app__aboutus app__bg flex__center section__padding" id="about">
    <div className="app__aboutus-content flex__center">
      <div className="app__aboutus-content_about">
        <img src={images.spoon} alt="about_spoon" className="spoon__img" />
        <h1 className="p__opensans"><Typewriter options={{ strings: ['Home Away From Home'], autoStart: true, loop: true, delay: 100 }} /></h1>
        <p className="p__opensans">39th RETROSPECT.</p>
        <p className="p__opensans">2019-2022.</p>
      </div>
      <div className="app__aboutus-content_history">
        <p className="p__opensans">                                                                                    </p>
      </div>
      <div className="app__aboutus-content_history">
        <p className="p__opensans">                                                                                                                   </p>
      </div>
    </div>
  </div>
);

export default AboutUs;
